import {Component, OnInit} from '@angular/core';
import {Router, RouterLink} from '@angular/router';
import { HttpClient } from '@angular/common/http';
import {map} from 'rxjs/operators';
import {environment} from '../../environments/environment';
import {DashboardMapComponent} from '../dashboard-map/dashboard-map.component';
import {HelpDocsLinksComponent} from '@shared/help-docs-links/help-docs-links.component';
import {FormsModule} from '@angular/forms';
import {NgForOf, NgIf} from '@angular/common';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    imports: [
        DashboardMapComponent,
        RouterLink,
        HelpDocsLinksComponent,
        FormsModule,
        NgForOf,
        NgIf
    ]
})
export class DashboardComponent implements OnInit {
  searchText: string;
  countSiteTypes = [
    'sites',
    'tierii/facilities',
    'solidwaste/facilities',
    'precerclis/sites',
    'beaches/monitoringlocation',
    'fuds/attributes',
    'brownfields/attributes',
    'standbygenerator/attributes',
    'ust/sites'
  ]
  counts: any = {}
  beachCounts = {
    last30days: {} as any,
    current: {} as any,
  }
  sw_currentquarter: any;
  advisory_type_codes;
  show_messages = false;
  total_permits: any;
  applications_to_review;
  permits_issued;
  ust_actions_past_due;
  basicCounts = [];

  constructor(public router: Router, public http: HttpClient) {
  }

  ngOnInit(): void {
    this.getSolidWasteCounts();
    this.getBeachCounts();
    this.getPermitCount();
    this.countSiteTypes.forEach((recordType) => {
      this.getBasicCount(recordType);
    });
  }

  searchSites(search: string) {
    this.router.navigate(['/site/list'], {queryParams: {search}})
  }

  getBasicCount(recordType: string) {
    return this.http.get(`${environment.baseUrl}/${recordType}/metadata/`).subscribe((meta: any) => {
      this.basicCounts.push({
        name: meta.verbose_name_plural,
        count: meta.count,
        dataset: recordType.split('/')[0] !== 'sites' ? recordType.split('/')[0] : ''
      });
    });
  }

  getSolidWasteCounts() {
    this.http.get(`${environment.baseUrl}/solidwaste/permits/statuscounts/`).subscribe((counts: any[]) => {
      counts.forEach((count) => {
        this.counts[count.status] = count.total;
      });
    });
    this.http.get(`${environment.baseUrl}/solidwaste/complaints/currentquarter/`).subscribe((counts) => {
      this.sw_currentquarter = counts;
    });
  }

  getBeachCounts() {
    this.http.get(`${environment.baseUrl}/beaches/advisoryactivity/metadata/`).subscribe((response: any) => {
      this.advisory_type_codes = response.fields.type_code.choices;
    });

    this.http.get(`${environment.baseUrl}/beaches/advisoryactivity/counts/`, {params: {'last30days': 'true'}}).subscribe((response: any) => {
      var total = 0;
      this.beachCounts.last30days = response.totals.reduce((a, item) => {
        a[item.type_code] = item.total;
        total += item.total;
        a.total = total;
        return a;
      }, {});
    });
    this.http.get(`${environment.baseUrl}/beaches/advisoryactivity/counts/`, {params: {current: 'true'}}).subscribe((response: any) => {
      var total = 0;
      this.beachCounts.current = response.totals.reduce((a, item) => {
        a[item.type_code] = item.total;
        total += item.total;
        a.total = total;
        return a;
      }, {});
    });
  }

  getPermitCount() {
    this.http.get(`${environment.baseUrl}/review/`, {
      params: {
        current_user: 'true',
        is_next: 'true'
      }
    }).subscribe((response: any) => {
      this.total_permits = response.meta.count;
      if (this.total_permits > 0) this.show_messages = true;
    });
    this.http.get(`${environment.baseUrl}/standbygenerator/permits/`, {
      params: {
        status: 'initial,resubmit',
        'fields!': 'emission_fee,tonnage,total_estimated_tonnage'
      }
    }).subscribe((response: any) => {
      this.applications_to_review = response.meta.permissions.write ? response.meta.count : 0;
      if (this.applications_to_review > 0) this.show_messages = true;
    });
    this.http.get(`${environment.baseUrl}/standbygenerator/permits/`, {params: {status: 'issued'}}).subscribe((response: any) => {
      this.permits_issued = response.meta.count;
      if (this.permits_issued > 0) this.show_messages = true;
    });
    this.http.get(`${environment.baseUrl}/ust/actions`, {params: {past_due: 'true'}}).subscribe((response: any) => {
      this.ust_actions_past_due = response.meta.count;
      if (this.ust_actions_past_due > 0) this.show_messages = true;
    });
  }
}
